document.addEventListener('DOMContentLoaded', function() {
  if (typeof Shopify !== 'undefined' && Shopify.product) {
    const stickyButton = document.getElementById('sticky-buy-now');
    const buyNowBtn = document.getElementById('buy-now-btn');
    if (!stickyButton || !buyNowBtn) return;

    stickyButton.style.display = 'block';

    buyNowBtn.addEventListener('click', function() {
      let variantId = Shopify.product.variants[0].id;
      if (Shopify.product.selected_or_first_available_variant) {
        variantId = Shopify.product.selected_or_first_available_variant.id;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
      .then(response => response.json())
      .then(() => { window.location.href = '/checkout'; })
      .catch(err => { alert('Error adding product to checkout'); console.error(err); });
    });
  }
});
